
import { AppState } from '@/types';
import { saveStateToBackend, loadStateFromBackend } from './api.service';
import { migrate } from './migration.service';

export const saveAppState = async (state: AppState): Promise<void> => {
  try {
    // Create a new object from the state, excluding the backgroundImage property.
    // The background image is managed in localStorage and should not be saved to the backend.
    const { backgroundImage, ...stateToSave } = state;

    // We cast here because saveStateToBackend expects a full AppState,
    // but we are intentionally sending one without the backgroundImage.
    // The backend is configured to handle this flexible object.
    await saveStateToBackend(stateToSave as AppState);
  } catch (error) {
    console.error("Failed to save state to backend", error);
  }
};

export const loadAppState = async (): Promise<AppState | null> => {
  try {
    const state = await loadStateFromBackend();
    if (state) {
      return migrate(state);
    }
    return null;
  } catch (error) {
    console.error("Failed to load state from backend", error);
    return null;
  }
};
